import http from '../http'
const API_URL = 'companies'

class CompanyAPI {
  async createCompany(company) {
    const response = await http(`${API_URL}/save`, 'POST', company)
    return response
  }

  async getAllCompanies() {
    const response = await http(`${API_URL}`)
    return response
  }

  async getCompany(companyID) {
    const response = await http(`${API_URL}/list/${companyID}`)
    return response
  }

  async getCompanyByUUID(uuid) {
    const response = await http(`${API_URL}/show/${uuid}`)
    return response
  }

  async getCompanyByDesign(id) {
    const response = await http(`${API_URL}/diseno/${id}`)
    return response
  }

  async getEmployees(companyID) {
    const response = await http(`sg-sst/employee/${companyID}`)
    return response
  }

  async updateCompany(company) {
    const response = await http(`${API_URL}/update`, 'PUT', company)
    return response
  }

  // Devuelve las empresas asignadas a un user_sst desde el SST (no SSO).
  // Usado por roles asignados (Cliente Admin / Talento Humano / Responsable Operativo).
  async getCompaniesByUserSst(userSstId) {
    const response = await http(`${API_URL}/by-user-sst/${userSstId}`)
    return response
  }

  // Sincroniza la lista de empresas asignadas a un usuario (por nodexum_id del SSO).
  // Se envian uuids (ids del SSO); el backend crea/enlaza la fila SST por uuid.
  // Se incluye el access_token del que asigna (admin/root) para que el backend
  // traiga el social_reason real desde el SSO y lo persista.
  // body: { company_uuids: [string, ...], access_token }
  async syncCompaniesByNodexum(nodexumId, companyUuids) {
    let accessToken = null
    try {
      accessToken = JSON.parse(localStorage.getItem('user')).token
    } catch (e) {
      accessToken = null
    }
    const response = await http(`${API_URL}/sync-by-nodexum/${nodexumId}`, 'POST', {
      company_uuids: companyUuids,
      access_token: accessToken,
    })
    return response
  }

  async employeesCount(companyID) {
    const response = await http(`${API_URL}/copass_appointed/${companyID}`)
    return response
  }

  async employeesCountAct(companyID) {
    const response = await http(`employee/company/is_active/${companyID}`)
    return response
  }

}

export default new CompanyAPI()